export const RESTITUTION_TYPE = {
    FIXED: 'fixed',
    AMOUNT: 'amount'
};
